import { ActingTonightOptionType } from './types';

export const ACTING_TONIGHT_OPTIONS: ActingTonightOptionType[] = [
  {
    id: 'flirting_with_you',
    title: 'Flirting with you',
    subtitle: "They're sending signals — subtle, but steady.",
    emoji: '😘',
  },
  {
    id: 'ignoring_you',
    title: 'Ignoring you',
    subtitle: 'You might as well be invisible... for now.',
    emoji: '🙄',
  },
  {
    id: 'checking_out_your_friend',
    title: 'Checking out your friend',
    subtitle: "Their eyes drift — and it's not in your direction.",
    emoji: '👀',
  },
  {
    id: 'coming_on_strong',
    title: 'Coming on strong',
    subtitle: "No hesitation. They're making the first move.",
    emoji: '❤️‍🔥',
  },
];
